export default "__VITE_ASSET__qKb7Hnlz__"